module.exports = __webpack_public_path__ + "img/cinema3.1a8de900.jpg";